/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode } from 'react'

import { makeVar, useReactiveVar } from '@apollo/client'
import { createPortal } from 'react-dom'

import { IS_BROWSER, TOAST_ROOT_ID } from '@web/libs/constants'

import Toast, { ToastProps } from '.'

interface GlobalToast {
  id: number
  props: ToastProps
}

let toastId = -1

const globalToastsVar = makeVar<GlobalToast[]>([])

export const openToast = (props: ToastProps) => {
  globalToastsVar([{ id: ++toastId, props }])
}

export const openErrorToast = (message: ReactNode) => openToast({ title: message, iconType: 'error', top: 0 })

export const openWarningToast = (message: ReactNode) => openToast({ title: message, iconType: 'warn', top: 0 })

export const closeAllToast = () => {
  globalToastsVar([])
}

const GlobalToastPortal = () => {
  const globalToasts = useReactiveVar(globalToastsVar)

  if (!IS_BROWSER) return null

  return createPortal(
    globalToasts.map(toast => <Toast key={toast.id} {...toast.props} />),
    document.getElementById(TOAST_ROOT_ID) as Element,
  )
}

export default GlobalToastPortal
